import gql from 'graphql-tag'

export default gql`
    query superAnalysis($startDate: String, $endDate: String) {
        superAnalysis(startDate: $startDate, endDate: $endDate) {
            Date
            UserCount {
                Total
                GroupSplit {
                    Name
                    Count
                }
            }
            SuperEngagementCount {
                Total
                GroupSplit {
                    Name
                    Count
                }
            }
        }
    }
`
